import { useEffect } from 'react'
import { initMetaPixel, trackPixel } from '../utils/metaPixel'
import { siteConfig } from '../data/siteConfig'

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel(siteConfig.metaPixelId)
    trackPixel('ViewContent', {
      content_name: 'PASEO PRO',
      content_type: 'product',
      value: siteConfig.priceValue,
      currency: siteConfig.priceCurrency,
    })
  }, [])
}
